<script setup>
defineProps({
  fieldModel: Object,
  disabled: Boolean,
  value: [Object, Boolean]
})
</script>

<template>
  <input
    type="radio"
    v-model="fieldModel.inputValue"
    :disabled="disabled || !fieldModel.editable"
    :class="{ 'is-invalid': fieldModel.hasErrors }"
    :value="value"
    :checked="(!value && !fieldModel.inputValue) || fieldModel.inputValue === value"
  />
</template>
